export const SAVE_MULTITUDES = 'SAVE_MULTITUDES';
export const SAVE_CURRENT_MULTITUDE = 'SAVE_CURRENT_MULTITUDE';